<app-page-content header="Oops! Page not found.">
  <ng-template #subtitle>
    <p class="text-4">This page doesn't exist. It may have moved, or the URL might be off.</p>
    <a routerLink="/">Back to home</a>
  </ng-template>
</app-page-content>
